import { useMemo } from 'react';

import { useUserFacilityRoles } from '@/hooks/query-hooks/use-user-facility-roles';

/**
 * Role-based access for equipment settings features that go beyond
 * the standard writeCommands privilege check.
 *
 * Currently only multi-select (bulk) editing requires an extra role gate
 * (Admin-only). Single-select editing and preview flows are already
 * covered by useActionPermission({ privilege: PRIVILEGES.writeCommands }).
 */
export const useEquipmentBulkEditAccess = () => {
  const { data: roleInfo, isLoading } = useUserFacilityRoles();

  const isAdmin = useMemo(
    () => roleInfo?.roles?.some((role) => role.name?.toLowerCase() === 'admin') ?? false,
    [roleInfo?.roles]
  );

  const rolesResolved = !isLoading && (roleInfo?.roles?.length ?? 0) > 0;
  const canUseMultiSelectEdit = rolesResolved && isAdmin;

  return {
    canUseMultiSelectEdit,
    multiSelectDeniedTooltip: !rolesResolved
      ? 'Checking role permissions...'
      : 'Your role does not have access to bulk edit.',
  };
};
